import DateTime, { MONTH_DAY_YEAR_HOUR_MINUTE_PERIOD } from '../../components/DateTime';
import moment from 'moment';
import { addUrlParametersFromCookieHistory, parseUrlParameters } from '../../actions/tracking';
import { Cookies } from 'react-cookie';
import { URL_PARAMS_HISTORY_COOKIE_NAME } from '../../config';

const cookies = new Cookies();

const appendUrlParamsToUrlParamsHistoryCookie = currentUrlParams => {
  const currentJson = {
    ...parseUrlParameters(currentUrlParams).payload.value,
    date: DateTime.format(moment())(MONTH_DAY_YEAR_HOUR_MINUTE_PERIOD),
  };
  // Get (if any) existing url params from history cookie and append the current ones
  const urlParametersHistory = cookies.get(URL_PARAMS_HISTORY_COOKIE_NAME) || [];
  urlParametersHistory.push(currentJson);

  // re-set the cookie
  cookies.set(URL_PARAMS_HISTORY_COOKIE_NAME, JSON.stringify(urlParametersHistory), {
    expires: new Date(new Date().setYear(2099)),
    path: '/',
  });
};

const dispatchUrlParamsCookieHistoryToState = context => {
  // Take the url params history from cookie and dispatch it to state
  const urlParamsHistCookie = new Cookies().get(URL_PARAMS_HISTORY_COOKIE_NAME);
  if (urlParamsHistCookie) {
    context.store.dispatch(addUrlParametersFromCookieHistory(urlParamsHistCookie));
  }
};

export { appendUrlParamsToUrlParamsHistoryCookie, dispatchUrlParamsCookieHistoryToState };
